import React from 'react';
import { useTranslation } from 'react-i18next';
import EnhancedGifPlayer from './EnhancedGifPlayer';
import { images } from '@/assets/images';

export default function YinYangSection() {
  const { t } = useTranslation();
  
  return (
    <section className="relative bg-dark py-12 sm:py-16 md:py-24 overflow-hidden overscroll-none">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))]
          from-primary/5 via-transparent to-transparent"></div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[linear-gradient(45deg,theme(colors.primary/0.5)_1px,transparent_1px),linear-gradient(-45deg,theme(colors.primary-light/0.5)_1px,transparent_1px)]"
               style={{ backgroundSize: '20px 20px', transform: 'perspective(1000px) rotateX(60deg)' }}></div>
        </div>

        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary/30 rounded-full animate-twinkle will-change-transform"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r 
              from-primary via-primary-light to-primary animate-gradient-x">
              {t('yinYang.title')}
            </span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto">
            {t('yinYang.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          <div className="relative group mx-auto w-full max-w-[500px]">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-primary-light 
              rounded-full blur-xl opacity-20 group-hover:opacity-40 animate-pulse"></div>
            
            <div className="relative w-[300px] sm:w-[400px] lg:w-[500px] aspect-square mx-auto">
              <div className="relative w-full h-full rounded-full bg-dark-lighter p-4 sm:p-8
                border border-primary/20 overflow-hidden group-hover:border-primary/50 
                transition-colors duration-500">
                <div className="relative w-full h-full">
                  <EnhancedGifPlayer 
                    src={images.nodeRocks.yinYang}
                    alt="Yin Yang Symbol"
                    className="w-full h-full object-contain rounded-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-primary-light/10 
                    mix-blend-overlay rounded-full opacity-50"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8 px-4 sm:px-0">
            <div className="card group hover:bg-dark-lighter/50">
              <div>
                <h3 className="text-xl font-bold mb-2 text-primary">{t('yinYang.history.title')}</h3>
                <p className="text-gray-300 text-base sm:text-lg" dangerouslySetInnerHTML={{
                  __html: t('yinYang.history.description', {
                    positive: '<span class="text-primary">positive</span>',
                    negative: '<span class="text-primary">negative</span>'
                  })
                }} />
              </div>
            </div>

            <div className="card group hover:bg-dark-lighter/50">
              <div>
                <h3 className="text-xl font-bold mb-2 text-primary">{t('yinYang.rarity.title')}</h3>
                <p className="text-gray-300 text-base sm:text-lg" dangerouslySetInnerHTML={{
                  __html: t('yinYang.rarity.description', {
                    count: '<span class="text-primary">70,000</span>',
                    total: '<span class="text-primary">472,043</span>',
                    block: '<span class="text-primary">Jubilee Block update (block 824,544)</span>'
                  })
                }} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {['Immutable', 'Decentralized', 'Scalable', 'Secure'].map((feature, index) => (
                <div key={index} className="card group p-3 sm:p-4 hover:bg-dark-lighter/50">
                  <p className="text-center text-sm sm:text-base font-semibold text-transparent bg-clip-text 
                    bg-gradient-to-r from-primary to-primary-light">
                    {feature}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}